import { LISTING_ORIGIN_TYPES } from '@/constants';

export const MIN_FINISHED_AREA = 0;
export const MAX_FINISHED_AREA = 5000;
export const FINISHED_AREA_OPTIONS = [
  {
    text: `${MIN_FINISHED_AREA}`,
    value: MIN_FINISHED_AREA,
  },
  {
    text: '500',
    value: 500,
  },
  {
    text: '1000',
    value: 1000,
  },
  {
    text: '1500',
    value: 1500,
  },
  {
    text: '2000',
    value: 2000,
  },
  {
    text: '3000',
    value: 3000,
  },
  {
    text: `${MAX_FINISHED_AREA}+`,
    value: MAX_FINISHED_AREA,
  },
];

export const MIN_BATHS = 0;
export const DEFAULT_BATH_OPTIONS = [
  { text: 'Any', value: MIN_BATHS },
  { text: '1+', value: 1 },
  { text: '2+', value: 2 },
  { text: '3+', value: 3 },
  { text: '4+', value: 4 },
  { text: '5+', value: 5 },
];

export const MIN_BEDS = 0;
export const DEFAULT_BEDS_OPTIONS = [
  { text: 'Any', value: MIN_BEDS },
  { text: '1+', value: 1 },
  { text: '2+', value: 2 },
  { text: '3+', value: 3 },
  { text: '4+', value: 4 },
  { text: '5+', value: 5 },
];

export const MIN_PARKING_VALUE = 0;
export const DEFAULT_PARKING_OPTIONS = [
  { text: '0', value: MIN_PARKING_VALUE },
  { text: '1', value: 1 },
  { text: '2', value: 2 },
  { text: '3', value: 3 },
  { text: '4', value: 4 },
  { text: '5+', value: 5 },
];

export const DEFAULT_MULTI_BEDS_OPTIONS = [
  { text: '0', value: 0 },
  { text: '1', value: 1 },
  { text: '2', value: 2 },
  { text: '3', value: 3 },
  { text: '4', value: 4 },
  { text: '5', value: 5 },
  { text: '6', value: 6 },
  { text: '7', value: 7 },
  { text: '8+', value: 8 },
];

export const DEFAULT_MULTI_BATHS_OPTIONS = [
  { text: '0', value: 0 },
  { text: '0.5', value: 0.5 },
  { text: '1', value: 1 },
  { text: '1.5', value: 1.5 },
  { text: '2', value: 2 },
  { text: '2.5', value: 2.5 },
  { text: '3', value: 3 },
  { text: '3.5', value: 3.5 },
  { text: '4', value: 4 },
  { text: '4.5', value: 4.5 },
  { text: '5+', value: 5 },
];

export const MIN_YEAR_BUILT = 1900;
export const MAX_YEAR_BUILT = new Date().getFullYear();
export const YEAR_BUILT_OPTIONS = [
  { text: `${MIN_YEAR_BUILT}`, value: MIN_YEAR_BUILT },
  { text: '1925', value: 1925 },
  { text: '1950', value: 1950 },
  { text: '1970', value: 1970 },
  { text: '1990', value: 1990 },
  { text: '2000', value: 2000 },
  { text: '2010', value: 2010 },
  { text: '2015', value: 2015 },
  { text: '2020', value: 2020 },
  { text: `${MAX_YEAR_BUILT}`, value: MAX_YEAR_BUILT },
];

export const MIN_LAND_SIZE = 0;
export const MAX_LAND_SIZE = 4;
export const LAND_SIZE_OPTIONS = [
  {
    text: `${MIN_LAND_SIZE}`,
    value: MIN_LAND_SIZE,
  },
  {
    text: '0.5',
    value: 0.5,
  },
  {
    text: '2.0',
    value: 2,
  },
  {
    text: `${MAX_LAND_SIZE}+`,
    value: MAX_LAND_SIZE,
  },
];

export const LISTING_TYPE_OPTIONS = [
  {
    text: 'Bōde Listings Only',
    value: LISTING_ORIGIN_TYPES.Bode,
  },
];

export const LISTING_STATUS_OPTIONS = [
  'Sold Bōde Listings',
];

export const MIN_PRICE = 0;
export const MAX_PRICE = 10000000;
export const PRICE_RANGE_OPTIONS = [
  { value: MIN_PRICE, text: '0' },
  { value: 25000, text: '25K' },
  { value: 50000, text: '50K' },
  { value: 75000, text: '75K' },
  { value: 100000, text: '100K' },
  { value: 125000, text: '125K' },
  { value: 150000, text: '150K' },
  { value: 175000, text: '175K' },
  { value: 200000, text: '200K' },
  { value: 225000, text: '225K' },
  { value: 250000, text: '250K' },
  { value: 275000, text: '275K' },
  { value: 300000, text: '300K' },
  { value: 325000, text: '325K' },
  { value: 350000, text: '350K' },
  { value: 375000, text: '375K' },
  { value: 400000, text: '400K' },
  { value: 425000, text: '425K' },
  { value: 450000, text: '450K' },
  { value: 475000, text: '475K' },
  { value: 500000, text: '500K' },
  { value: 550000, text: '550K' },
  { value: 600000, text: '600K' },
  { value: 650000, text: '650K' },
  { value: 700000, text: '700K' },
  { value: 750000, text: '750K' },
  { value: 800000, text: '800K' },
  { value: 850000, text: '850K' },
  { value: 900000, text: '900K' },
  { value: 950000, text: '950K' },
  { value: 1000000, text: '1M' },
  { value: 1100000, text: '1.1M' },
  { value: 1200000, text: '1.2M' },
  { value: 1300000, text: '1.3M' },
  { value: 1400000, text: '1.4M' },
  { value: 1500000, text: '1.5M' },
  { value: 1600000, text: '1.6M' },
  { value: 1700000, text: '1.7M' },
  { value: 1800000, text: '1.8M' },
  { value: 1900000, text: '1.9M' },
  { value: 2000000, text: '2M' },
  { value: 2250000, text: '2.25M' },
  { value: 2500000, text: '2.5M' },
  { value: 2750000, text: '2.75M' },
  { value: 3000000, text: '3M' },
  { value: 3500000, text: '3.5M' },
  { value: 4000000, text: '4M' },
  { value: 4500000, text: '4.5M' },
  { value: 5000000, text: '5M' },
  { value: 6000000, text: '6M' },
  { value: 7000000, text: '7M' },
  { value: 8000000, text: '8M' },
  { value: 9000000, text: '9M' },
  { value: MAX_PRICE, text: '10M+' },
];

export const COMMUNITIES_OPTION_PLACEHOLDER = 'No communities available';
